import { render, staticRenderFns } from "./ArtistListNew.vue?vue&type=template&id=48241016&scoped=true&"
import script from "./ArtistListNew.vue?vue&type=script&lang=js&"
export * from "./ArtistListNew.vue?vue&type=script&lang=js&"
import style0 from "./ArtistListNew.vue?vue&type=style&index=0&id=48241016&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48241016",
  null
  
)

export default component.exports